function install(Vue) {
  Vue.mixin({
    methods: {
      $getAge(birthDate) {
        if (!birthDate) return null;
        const ageDifMs = Date.now() - new Date(birthDate);
        const ageDate = new Date(ageDifMs);
        return ageDate.getUTCFullYear() - 1970;
      }
    }
  });
}

export default { install };
